/**
 * Setting local del POS: si consolidar items repetidos en el carrito.
 *
 * Vive en `shared` (no en `pos`) para que pueda ser importado tanto por
 * `useSessionStore` (shell/session) como por `usePosStore` (pos) sin
 * violar los boundaries del módulo `pos` ni generar require cycles.
 *
 * El session store actualiza este valor cuando cambia la sucursal activa
 * o el setting de la sucursal. El POS lo lee en `addProductToCart`.
 *
 * Default true (merge por defecto, alineado con Square/Toast/BIGPOS).
 */

let consolidateCartLines = true;

export function getConsolidateCartLines(): boolean {
  return consolidateCartLines;
}

export function setConsolidateCartLines(value: boolean): void {
  consolidateCartLines = value;
}
